import api from '@/plugins/request/index';
import { param } from 'jquery';

// 获取当前登录公司所有部门层级
export const getCompanyAllChild = async (type = 'get') => {
  return api[type]('/gateway/v1/dept/list-by-company').then(res => res);
}
// 根据上级部门id查找下级部门列表
export const getDepartListById = async (upId, params, type = 'get') => {
  return api[type](`/gateway/v1/dept/low-level/${upId}`, params).then(res => res);
}
// 添加部门信息
export const addDepartment = async (params, type = 'post') => {
  return api[type](`/gateway/v1/dept`, params).then(res => res);
}
// 编辑部门信息
export const editDepartment = async (id, params, type = 'put') => {
  return api[type](`/gateway/v1/dept/${id}`, params).then(res => res);
}
// 删除部门信息
export const deleteDepartment = async (id, type = 'delete') => {
  return api[type](`/gateway/v1/dept/${id}`).then(res => res);
}
// 查询经纪人列表
export const getMemberList = async (params, type = 'get') => {
  return api[type](`/gateway/v1/admin`, params).then(res => res);
}
// 查询经纪人客户列表
export const getCustomByMember = async (params, type = 'get') => {
  return api[type](`/gateway/v1/customer/before-del-admin/admin/${params.id}/customer-remaining`,params).then(res => res);
}
// 从商户删除经纪人前置检查
export const checkMemberCustom = async (id, type = 'get') => {
  return api[type](`/gateway/v1/customer/before-del-admin/admin/${id}/customer-remaining-check`).then(res => res);
}
// 添加经纪人
export const setMemberList = async (params, type = 'post') => {
  return api[type](`/gateway/v1/admin`, params).then(res => res);
}
// 查看经纪人
export const getMemberById = async (id, type = 'get') => {
  return api[type](`/gateway/v1/admin/${id}`).then(res => res);
}
// 修改经纪人
export const editMemberList = async (id, params, type = 'put') => {
  return api[type](`/gateway/v1/admin/${id}`, params).then(res => res);
}
// 删除经纪人
export const removeMemberList = async (id, params, type = 'delete') => {
  return api[type](`/gateway/v1/admin/${id}`, params).then(res => res);
}
// 删除经纪人
export const editMemberStatus = async (id, type = 'put') => {
  return api[type](`/gateway/v1/admin/${id}/change-status`).then(res => res);
}
// 角色自动查询
export const getRoleAutoComplete = async (params, type = 'get') => {
  return api[type](`/gateway/v1/admin/role/all`, params).then(res => res);
}
// 查询角色列表
export const getRoleList = async (params, type = 'get') => {
  return api[type](`/gateway/v1/admin/role`, params).then(res => res);
}
// 添加角色
export const AddRole = async (params, type = 'post') => {
  return api[type](`/gateway/v1/admin/role`, params).then(res => res);
}
// 编辑角色
export const editRole = async (id, params, type = 'put') => {
  return api[type](`/gateway/v1/admin/role/${id}`, params).then(res => res);
}
// 删除角色
export const deleteRole = async (id, type = 'delete') => {
  return api[type](`/gateway/v1/admin/role/${id}`).then(res => res);
}
// 切换角色状态
export const changeRoleStatus = async (id, type = 'put') => {
  return api[type](`/gateway/v1/admin/role/${id}/change-status`).then(res => res);
}
// 查询角色下人员列表
export const getEmployeeByRole = async (id, params, type = 'get') => {
  return api[type](`/gateway/v1/admin/role/${id}/admins`, params).then(res => res);
}
// 查询角色短信配置列表
export const getRoleSmsList = async (params, type = 'get') => {
  return api[type](`/gateway/v1/admin/role/sms`, params).then(res => res);
}
// 修改角色短信配置列表
export const setRoleSmsList = async (params, type = 'put') => {
  return api[type](`/gateway/v1/admin/role/sms-status`, params).then(res => res);
}
// 查询某个用户的操作权限
export const getUserOperatePermission = async (params, type = 'get') => {
  return api[type](`/gateway/v1/permissions/operate-permission-for-detail`, params).then(res => res);
}
// 查询某个角色的操作权限
export const getRoleOperatePermission = async (params, type = 'get') => {
  return api[type](`/gateway/v1/permissions/operate-permission-for-edit`, params).then(res => res);
}
// 获取用户登录日志
export const getUserLoginLog = async (params, type = 'get') => {
  return api[type](`/gateway/v1/log/login`, params).then(res => res);
}
// 修改角色权限
export const edtiRolePermission = async (id, params, type = 'put') => {
  return api[type](`/gateway/v1/admin/role/${id}/operate-permission`, params).then(res => res);
}
// 修改角色数据权限
export const editRoleDataPermission = async (id, params, type = 'put') => {
  return api[type](`/gateway/v1/admin/role/${id}/permission`, params).then(res => res);
}
// 获取角色详情
export const getRoleDetailById = async (id, type = 'get') => {
  return api[type](`/gateway/v1/admin/role/${id}`).then(res => res);
}
// 公告列表
export const getNoticeList = async (params, type = 'get') => {
  return api[type](`/gateway/v1/notice`, params).then(res => res);
}
// 添加公告
export const addNotice = async (params, type = 'post') => {
  return api[type](`/gateway/v1/notice`, params).then(res => res);
}
// 添加公告
export const editNotice = async (id, params, type = 'put') => {
  return api[type](`/gateway/v1/notice/${id}`, params).then(res => res);
}
// 删除公告
export const removeNotice = async (id, type = 'delete') => {
  return api[type](`/gateway/v1/notice/${id}`).then(res => res);
}
// 复制角色
export const copyRoleById = async (params, type = 'post') => {
  return api[type](`/gateway/v1/admin/role/copy`, params).then(res => res);
}
// 全部操作列表
export const getOperateList = async (params, type = 'get') => {
  return api[type](`/gateway/v1/log/action-log`, params).then(res => res);
}
// 筛选-全部操作对象列表
export const getOperateObjectList = async (type = 'get') => {
  return api[type](`/gateway/v1/log/action-log/objects-all`).then(res => res);
}
// 筛选-全部操作动作列表
export const getOperateActionList = async (type = 'get') => {
  return api[type](`/gateway/v1/log/action-log/actions-all`).then(res => res);
}
// 获取当前企业自建应用详情
export const getWechatAppInfo = async (type = 'get') => {
  return api[type](`/gateway/v1/company/we-work/self-built-setting`).then(res => res);
}
// 删除当前自建应用
export const removeWechatAppInfo = async (type = 'delete') => {
  return api[type](`/gateway/v1/company/we-work/self-built-setting`).then(res => res);
}
// 筛选-全部操作动作列表
export const getUnActiveList = async (params, type = 'get') => {
  return api[type](`/gateway/v1/we-work/not-active-user`, params).then(res => res);
}
// 获取企微通讯录更新情况
export const getWechatConcatUpdate = async (type = 'get') => {
  return api[type](`/gateway/v1/we-work/not-active-user/syn-status`).then(res => res);
}
// 手动同步通讯录
export const asyncWechatConcatUpdate = async (type = 'get') => {
  return api[type](`/gateway/v1/we-work/syn-contact`).then(res => res);
}
// 绑定业务微信
export const bindWechat = async (id, type = 'put') => {
  return api[type](`/gateway/v1/we-work/admin/${id}/create-new-contact`).then(res => res);
}
// 待审核经纪人列表
export const approveAdminList = async (params, type = 'get') => {
  return api[type](`/gateway/v1/admin/join-list`, params).then(res => res);
}
// 审核待审核经纪人
export const approveAdmin = async (params, type = 'post') => {
  return api[type](`/gateway/v1/admin/join-approval-company`, params).then(res => res);
}
// 邀请经纪人
export const inviteAdmin = async (id, params, type = 'put') => {
  return api[type](`/gateway/v1/admin/join-invite/${id}`, params).then(res => res);
}
// 撤销邀请经纪人
export const cancelInviteAdmin = async (params, type = 'post') => {
  return api[type](`/gateway/v1/admin/cancel-invite-join`, params).then(res => res);
}
// 查看初始密码
export const resetPwd = async (params, type = 'put') => {
  return api[type](`/gateway/v1/admin/join-approval-company/reset-pwd`, params).then(res => res);
}
// 重新经纪人
export const repeatInviteAdmin = async (params, type = 'post') => {
  return api[type](`/gateway/v1/admin/repeat_invite_join`, params).then(res => res);
}
// 批量邀请经纪人
export const inviteAdminBatch = async (params, type = 'put') => {
  return api[type](`/gateway/v1/admin/join-invite-batch`, params).then(res => res);
}
// 激活用户-返回激活状态
export const activeUnActiveUser = async (id, type = 'put') => {
  return api[type](`/gateway/v1/we-work/not-active-user/${id}/active`).then(res => res);
}
// 获取未绑定企业经纪人列表
export const getUnActiveUserList = async (type = 'get') => {
  return api[type](`/gateway/v1/we-work/no-we-work-admin`).then(res => res);
}
// 未激活列表-激活并关联经纪人
export const activeUnActiveUserAndRelative = async (id, adminID, type = 'put') => {
  return api[type](`/gateway/v1/we-work/not-active-user/${id}/active-with-admin/${adminID}`).then(res => res);
}

// 根据名称获取指定级别地址
export const getCityAutoComplete = async (params, type = 'get') => {
  return api[type](`/gateway/v1/city/level-search`, params).then(res => res);
}
//获取公司绑定的抖音号码(
export const getBindDouyinInfo = async (type = 'get') => {
  return api[type](`/gateway/v1/douyin/company/bind-info`).then(res => res);
}
//解绑公司绑定的抖音号码
export const unBindDouyinAcc = async (id,type = 'delete') => {
  return api[type](`/gateway/v1/douyin/company/bind/${id}`).then(res => res);
}
  //获取经纪人绑定的抖音号码(
export const getAgentDouyinInfo = async (id,type = 'get') => {
  return api[type](`/gateway/v1/douyin/admin/${id}/bind-info`).then(res => res);
}
//解绑经纪人绑定的抖音号码
export const unBindAgentAcc = async (id,type = 'delete') => {
  return api[type](`/gateway/v1/douyin/admin/bind/${id}`).then(res => res);
}
//获取企业休假设置
export const getCompanyVocationSet = async (type = 'get') => {
  return api[type](`/gateway/v1/company/business-setting/vacation`).then(res => res);
}
//设置企业休假
export const setCompanyVocationSet = async (params, type = 'put') => {
  return api[type](`/gateway/v1/company/business-setting/vacation`, params).then(res => res);
}